import dateTimeHelper from './datetimeHelper';

// Pure date logic for the fieldwork-period tables, ported verbatim from the old
// (deleted) PlanningItem multi-edit panel (CD-5218). `timespan` is one of:
// weekly | monthly | bimonthly | quarterly | yearly | other.
export class fieldworkPeriodDateHelper {
  static getTimeSpanForPeriodCount(numberOfPlanningDetails) {
    switch (numberOfPlanningDetails) {
      case 52:
        return 'weekly';
      case 12:
        return 'monthly';
      case 6:
        return 'bimonthly';
      case 4:
        return 'quarterly';
      case 1:
        return 'yearly';
      default:
        return 'other';
    }
  }

  static addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  // Builds the default Periods array for the PI MultiEdit wizard from the
  // GetPlanningDetailsDatesByPricingIds result. The comparison semantics are the
  // old panel's, on purpose — do not add date parsing here.
  static generateDefaultPeriods(numberOfPeriods, fetchedDates) {
    const dates = fetchedDates ?? [];
    let useFetched = true;
    for (let i = 1; i < dates.length; i++) {
      if (dates[i].startDate !== dates[0].startDate) {
        useFetched = false;
        break;
      }
    }

    const today = new Date();
    const longAgo = new Date(today.getFullYear() - 20, today.getMonth(), today.getDate());
    const periods = [];
    for (let i = 0; i < numberOfPeriods; i++) {
      const fallback = fieldworkPeriodDateHelper.addDays(
        new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12, 0, 0),
        i
      );
      periods.push({
        apply: useFetched,
        startDate: useFetched && dates[i] !== undefined && dates[i].startDate > longAgo ? dates[i].startDate : fallback,
        endDate: useFetched && dates[i] !== undefined && dates[i].endDate > longAgo ? dates[i].endDate : fallback,
      });
    }
    return periods;
  }

  // Mutates startDates/endDates in place (the callers build fresh arrays first).
  static adjustDates(startDates, endDates, indexOfRow, type, timespan) {
    const base = type === 'StartDate' ? startDates[indexOfRow] : endDates[indexOfRow];
    if (indexOfRow === 0 && timespan !== 'other') {
      fieldworkPeriodDateHelper.adjustDatesByTimeSpan(startDates, endDates, type, timespan);
      return;
    }
    for (let i = 0; i < startDates.length; i++) {
      if (i < indexOfRow) {
        if (startDates[i] > base) startDates[i] = base;
        if (endDates[i] > base) endDates[i] = base;
      }
      if (i === indexOfRow) {
        if (type === 'StartDate') {
          if (endDates[i] < base) endDates[i] = base;
        } else if (startDates[i] > base) {
          startDates[i] = base;
        }
      }
      if (i > indexOfRow) {
        if (startDates[i] < base) startDates[i] = base;
        if (endDates[i] < base) endDates[i] = base;
      }
    }
  }

  static adjustDatesByTimeSpan(startDates, endDates, type, timespan) {
    let monthsToAdd;
    let first;
    let year;
    let month;
    let day;

    if (type === 'StartDate') {
      for (let i = 0; i < startDates.length; i++) {
        switch (timespan) {
          case 'weekly':
            if (i > 0) {
              startDates[i] = fieldworkPeriodDateHelper.addDays(startDates[i - 1], 7);
            }
            endDates[i] = fieldworkPeriodDateHelper.addDays(startDates[i], 6);
            break;

          case 'monthly':
            monthsToAdd = 1;
            if (i > 0) {
              first = new Date(startDates[i - 1]);
              startDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate());
            }
            first = new Date(startDates[i]);
            endDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate() - 1, 12, 0, 0);
            break;

          case 'bimonthly':
          case 'quarterly':
            monthsToAdd = timespan === 'bimonthly' ? 2 : 3;
            if (i > 0) {
              first = new Date(startDates[0]);
              startDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd * i, first.getDate());

              first = new Date(endDates[0]);
              year = first.getFullYear();
              month = first.getMonth() + monthsToAdd * i;
              day = first.getDate();
              if (day >= 28) day = 31;
              day = dateTimeHelper.LimitDayNumber(year, month, day);

              endDates[i] = new Date(year, month, day);
            } else {
              first = new Date(startDates[0]);
              endDates[0] = new Date(
                first.getFullYear(),
                first.getMonth() + monthsToAdd,
                first.getDate() - 1,
                12,
                0,
                0
              );
            }
            break;

          case 'yearly':
            monthsToAdd = 12;
            if (i > 0) {
              first = new Date(startDates[i - 1]);
              startDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate());
            }
            first = new Date(startDates[i]);
            endDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate() - 1, 12, 0, 0);
            break;

          default:
            break;
        }
      }
      return;
    }

    for (let i = 1; i < endDates.length; i++) {
      switch (timespan) {
        case 'weekly':
          endDates[i] = fieldworkPeriodDateHelper.addDays(endDates[i - 1], 7);
          break;

        case 'monthly':
          monthsToAdd = 1;
          first = new Date(endDates[i - 1]);
          endDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate(), 12, 0, 0);
          break;

        case 'bimonthly':
        case 'quarterly':
          monthsToAdd = timespan === 'bimonthly' ? 2 : 3;
          first = new Date(endDates[0]);
          year = first.getFullYear();
          month = first.getMonth() + monthsToAdd * i;
          day = first.getDate();
          if (day >= 28) day = 31;
          day = dateTimeHelper.LimitDayNumber(year, month, day);
          endDates[i] = new Date(year, month, day);
          break;

        case 'yearly':
          monthsToAdd = 12;
          first = new Date(endDates[i - 1]);
          endDates[i] = new Date(first.getFullYear(), first.getMonth() + monthsToAdd, first.getDate(), 12, 0, 0);
          break;

        default:
          break;
      }
    }
  }
}

export default fieldworkPeriodDateHelper;
